/**
 * 解析 linkUrl（JSON 或旧版 URL）并跳转（与装修 DecorationRenderer.goLink 一致）
 */

const SYSTEM_PAGE_PC = {
  index: '/index',
  category: '/classification',
  search: '/searchGoods',
  cart: '/cart',
  member: '/userInfo/dashboard',
  seckill: '/flash-sale',
  groupBuy: '/group',
  couponCenter: '/coupon/center',
  pointMall: '/point/mall',
  pointLottery: '/point/lottery',
  live: '/live/list',
  myOrder: '/userInfo/my-order',
  myCoupon: '/userInfo/coupon',
  myFavorite: '/userInfo/collect-goods',
  myPoint: '/userInfo/point',
  myBalance: '/userInfo/balance',
  footprint: '/userInfo/footprint',
  memberVip: '/member/center',
  storeList: '/store/list',
  announcement: '/announcement/list'
}

export function parseLinkFromStorage (linkUrl) {
  const raw = linkUrl != null ? String(linkUrl).trim() : ''
  if (!raw) return null
  if (raw.startsWith('{')) {
    try {
      const o = JSON.parse(raw)
      if (o && o.linkType && o.linkType !== 'none' && o.value) return o
    } catch (e) { /* legacy */ }
  }
  if (/^https?:\/\//i.test(raw)) {
    return { linkType: 'url', value: raw }
  }
  return { linkType: 'url', value: raw }
}

export function navigateByLink (router, linkOrUrl) {
  const link = typeof linkOrUrl === 'object' && linkOrUrl && linkOrUrl.linkType
    ? linkOrUrl
    : parseLinkFromStorage(linkOrUrl)
  if (!link || !link.linkType || link.linkType === 'none' || !link.value) return

  switch (link.linkType) {
    case 'goods':
      router.push({ path: '/productDetails', query: { id: link.value } })
      break
    case 'category':
      router.push({ path: '/commodity', query: { id: link.value } })
      break
    case 'customPage':
      router.push({ path: '/page/' + link.value })
      break
    case 'systemPage': {
      const path = SYSTEM_PAGE_PC[link.value]
      if (path) router.push({ path })
      break
    }
    case 'url':
      if (/^https?:\/\//i.test(link.value)) {
        window.open(link.value)
      } else if (link.value.startsWith('/')) {
        router.push({ path: link.value })
      }
      break
    default:
      break
  }
}
